function LearnMoreDialogBox() {
  return (
    <div className="learn">
      <aside className="learn_more">
          <h1>Want to learn more?</h1>
          <p>Subcribe to our newsletter and never miss out on the latest news on Medbolt</p>
          <input type="text" placeholder="Enter your email" />
          <button>Join now</button>
      </aside>
    </div>
  )
}

export default LearnMoreDialogBox